import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "@/lib/api";

// Código curto do subdomínio da agência (kwselect.imodesk.pt/uu2rnex), quando servido diretamente.
export const subdomainCode = () => {
  const m = window.location.hostname.match(/^([a-z0-9-]+)\.imodesk\.pt$/);
  const c = window.location.pathname.match(/^\/([A-Za-z0-9]{6,10})\/?$/);
  return m && m[1] !== "www" && c ? c[1] : null;
};

// /c/:código, /:slug/p/:código (antigo) e subdomínio: o código identifica o link; o slug é só para mostrar.
export default function ShortLink({ code: fixed }) {
  const params = useParams();
  const code = fixed || params.code;
  const navigate = useNavigate();
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/public/c/${code}`).then(({ data }) => navigate(`/portal/${data.token}`, { replace: true })).catch(() => setErr(true));
  }, [code, navigate]);
  return (
    <div className="min-h-screen grid place-items-center text-slate-500" data-testid="short-link">
      {err ? "Esta ligação não é válida. Peça uma nova ao seu consultor." : "A abrir…"}
    </div>
  );
}
